import Accordion from '../components/accordion'

export default function () {
    const accordions = [...document.querySelectorAll('.accordion')]

    accordions.forEach((accordion) => {
        (new Accordion(accordion)).init()
    })
}